import { render, staticRenderFns } from "./MainDetailIcons.vue?vue&type=template&id=3d091bf4"
import script from "./MainDetailIcons.vue?vue&type=script&lang=ts"
export * from "./MainDetailIcons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports